import * as React from "react";

export interface GenerateAriaDescriptionResult {
  ariaDescriptionId?: string;
  ariaDescriptionElement?: JSX.Element;
}

/**
 * Utility function for generating a DOM element containing aria description that can be referenced
 * via an id in aria-describedby attribute
 */
export const generateAriaDescription = (
  targetElementId?: string,
  description?: string
): GenerateAriaDescriptionResult => {
  const result: GenerateAriaDescriptionResult = {
    ariaDescriptionId: undefined,
    ariaDescriptionElement: undefined,
  };
  if (description && targetElementId) {
    result.ariaDescriptionId = `${targetElementId}-aria-describedby`;
    result.ariaDescriptionElement = (
      <span id={result.ariaDescriptionId} style={{ display: "none" }}>
        {description}
      </span>
    );
  }
  return result;
};
